import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { type Distribution, type LensDestination } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { type GetLensDestinationsQuery, getLensDestinations } from "../api/queries";
import { addAdAccountsFromLensCentralDistributions } from "../state";

export interface LensDestinationsResult {
    destinations: readonly LensDestination[];
}

export const useLensDestinations = (
    lensId: string | undefined,
    lensFolderId: string | undefined,
    distributionsList: readonly Distribution[],
): ApolloResult<LensDestinationsResult> => {
    const { data, error, loading } = useQuery<GetLensDestinationsQuery>(getLensDestinations, {
        variables: { lensId, lensFolderId },
        errorPolicy: "all", // to keep the partial data,
        skip: !lensId || !lensFolderId,
    });

    const destinations = useMemo(
        () =>
            addAdAccountsFromLensCentralDistributions(
                data?.getLensDestinations.destinations ?? [],
                distributionsList,
                lensId ?? "",
            ),
        [data?.getLensDestinations.destinations, distributionsList, lensId],
    );
    return {
        destinations,
        loading,
        error,
    };
};
